import { Routes, Route } from 'react-router-dom'
import { PageShell } from '@/components/layout/PageShell'
import { HomePage } from '@/routes/HomePage'
import { AboutPage } from '@/routes/AboutPage'
import { ProgramsPage } from '@/routes/ProgramsPage'
import { ProgramDetailPage } from '@/routes/ProgramDetailPage'
import { TeamsPage } from '@/routes/TeamsPage'
import { CoachesPage } from '@/routes/CoachesPage'
import { CampsPage } from '@/routes/CampsPage'
import { GalleryPage } from '@/routes/GalleryPage'
import { UniformsPage } from '@/routes/UniformsPage'
import { SponsorsPage } from '@/routes/SponsorsPage'
import { RegisterPage } from '@/routes/RegisterPage'
import { ScholarshipPage } from '@/routes/ScholarshipPage'
import { ContactPage } from '@/routes/ContactPage'
import { DonatePage } from '@/routes/DonatePage'
import { PaymentsPage } from '@/routes/PaymentsPage'
import { NotFoundPage } from '@/routes/NotFoundPage'

export default function App() {
  return (
    <Routes>
      <Route element={<PageShell />}>
        <Route index element={<HomePage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="programs" element={<ProgramsPage />} />
        <Route path="programs/:slug" element={<ProgramDetailPage />} />
        <Route path="teams" element={<TeamsPage />} />
        <Route path="coaches" element={<CoachesPage />} />
        <Route path="camps" element={<CampsPage />} />
        <Route path="gallery" element={<GalleryPage />} />
        <Route path="uniforms" element={<UniformsPage />} />
        <Route path="sponsors" element={<SponsorsPage />} />
        <Route path="register" element={<RegisterPage />} />
        <Route path="scholarship" element={<ScholarshipPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="donate" element={<DonatePage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
